<pagination-template [id]="id"
                     (pageChange)="changePageNumber($event)"
                     #paginator="paginationApi">

  <ul class="pagination pb-0 pt-0">

    <li class="pagination-prev ml-0 mr-0 pl-0 pr-0">

      <a class="paginationButton page-control"
         title="{{ previousTitle }}"
         [ngClass]="{
           'disabled': disabled,
           'invisible': paginator.isFirstPage()
         }"
         (click)="disabled || paginator.previous()">
        <i class="fa-regular fa-angle-left"></i>
        <span>{{ previousLabel }}</span>
      </a>

    </li>

    <li class="pagination-next ml-0 mr-0 pl-0 pr-0">

      <a class="paginationButton page-control"
         title="{{ nextTitle }}"
         [ngClass]="{
           'disabled': disabled,
           'invisible': paginator.isLastPage()
         }"
         (click)="disabled || paginator.next()">
        <span>{{ nextLabel }}</span>
        <i class="fa-regular fa-angle-right"></i>
      </a>

    </li>

    <li class="ml-0 mr-0 pl-0 pr-0"
        *ngFor="let page of paginator.pages">

      <a class="paginationButton page-control"
         title="{{ pageNumberPrefix }}&nbsp;{{ page.label }}"
         [ngClass]="{
             'disabled': disabled && paginator.getCurrent() !== page.value,
             'current': paginator.getCurrent() === page.value
           }"
         (click)="disabled || paginator.setCurrent(page.value)">
        {{ page.label }}
      </a>

    </li>

  </ul>

</pagination-template>
